import { render, staticRenderFns } from "./account.order.vue?vue&type=template&id=36dcf9c6&"
import script from "./account.order.vue?vue&type=script&lang=js&"
export * from "./account.order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports